import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Divider,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useApi } from "../../api/useApi";
import Notification from "../Notification";
import GlassLoaderOverLay from "../GlassLoader";
import { ReactComponent as DomainArrowIcon } from "../../assets/images/Vector.svg";
import PhoneInput from "react-country-phone-input";
import "react-country-phone-input/lib/style.css";
import { phonePatterns } from "../PhonePatterns";
import ContactUsPopup from "../ContactusPage";
//export default function SignupFormContent({ onSwitchToLogin }) {
export default function SignupFormContent({
  onSwitchToLogin,
  onSwitchToSignup,
}) {
  const { request, loading } = useApi();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    domain: "",
    role: "",
    // category: "",
  });

  const [domainOptions, setDomainOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [phoneNumber, setPhoneNumber] = useState();
  const [open, setOpen] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const [notif, setNotif] = useState({
    open: false,
    success: true,
    text: "",
  });

  // ------------------------------
  // FETCH DOMAIN & ROLES
  // ------------------------------
  useEffect(() => {
    request({ url: "/domain-roles", method: "GET" })
      .then((res) => setDomainOptions(res))
      .catch(() => {
        setNotif({
          open: true,
          success: false,
          text: "Failed to load domain options.",
        });
      });
  }, []);

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  // ------------------------------
  // FIELD CHANGE HANDLER
  // ------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error
  };
  function validatePhone(phone, countryCode) {
    const digits = phone.replace(/\D/g, "");
    const entry = phonePatterns[countryCode?.toUpperCase()];
    if (!entry) return null;
    return entry.pattern.test(digits);
  }

  const handlePhoneChange = (value, countryData) => {
    setPhoneNumber(value ?? "");
    const iso = countryData?.countryCode?.toUpperCase();
    const dialCode = countryData?.dialCode ?? "";
    const localNumber = (value ?? "").replace(/\D/g, "").slice(dialCode.length);
    const valid = validatePhone(localNumber, iso);
    setPhoneError(
      valid === false
        ? `Invalid ${countryData?.name} number — ${phonePatterns[iso]?.hint}`
        : "",
    );
  };
  const labelSx = {
    mb: 0.5,
    fontFamily: "Akkurat-Pro",
    fontSize: { xs: "0.8rem", lg: "0.75rem", xl: "0.9rem" },
    color: "#525252",
  };
  const errorSx = { color: "red", fontSize: "0.75rem" };

  // ------------------------------
  // VALIDATION
  // ------------------------------
  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Full Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";

    if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Invalid email address";

    if (!String(phoneNumber || "").trim()) {
      newErrors.phone = "Phone number is required";
    } else if (phoneError) {
      newErrors.phone = phoneError;
    }

    if (!formData.domain) newErrors.domain = "Domain is required";
    if (!formData.role) newErrors.role = "Role is required";
    // if (!formData.category) newErrors.category = "Category is required";
    // if (!formData.emailContact && !formData.phoneContact)
    //   newErrors.contactPreference = "Contact Preference is required";
    if(!formData?.isAgree) newErrors.isAgree="Please accept the disclaimer to continue.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ------------------------------
  // SUBMIT HANDLER
  // ------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      userName: formData.name,
      emailId: formData.email,
      phoneNumber: phoneNumber,
      userDomain: formData.domain,
      // domain: formData.category,
      userRole: formData.role,
      contactPreference:
        formData.emailContact && formData.phoneContact
          ? "Email,Phone"
          : formData.phoneContact
            ? "Phone"
            : formData.emailContact
              ? "Email"
              : "",
    };

    try {
      const exists = await request({
        url: "/user/exists",
        method: "GET",
        params: { email: formData.email },
      });

      if (exists.exists) {
        return setNotif({
          open: true,
          success: false,
          text: "User already exists. Try logging in.",
        });
      }

      const res = await request({
        url: "/user/add",
        method: "POST",
        data: payload,
      });

      if (res) {
        setNotif({
          open: true,
          success: true,
          text: "Your account has been successfully created for the Sandhata DevOps and SRE Compass. Redirecting you to the login page to begin your assessment.",
        });

        // Clear form
        setFormData({
          name: "",
          email: "",
          phone: "",
          domain: "",
          role: "",
          // category: "",
        });
        setPhoneNumber();

        // ⏳ wait 2 seconds before switching to login
        setTimeout(() => {
          if (onSwitchToLogin) onSwitchToLogin();
        }, 2000);

        // Switch to Login page
        //if (onSwitchToLogin) onSwitchToLogin();
      }
    } catch (err) {
      console.error(err);
      setNotif({
        open: true,
        success: false,
        text: "Failed to create account. Try again later.",
      });
    }
  };

  return (
    <Box
      sx={{
        width: {
          xs: "90%",
          sm: "90%",
          md: "80%",
          lg: "95%",
          xl: "80%",
        },
        display: "flex",
        flexDirection: "column",
        gap: 3, // ⭐ uniform spacing for EVERYTHING
      }}
    >
      {/* Title */}
      <Box>
        <Typography
          sx={{
            fontFamily: "Akkurat-Bold",
            color: "#0036DD",
            fontSize: {
              xs: "0.9rem",
              sm: "0.9rem",
              md: "0.9rem",
              lg: "0.9rem",
              xl: "1.1rem",
            },
            mb: 0.5,
          }}
        >
          DevOps and SRE Compass
        </Typography>

        <Typography
          sx={{
            color: "#525252",
            fontFamily: "Akkurat-Pro",
            fontSize: {
              xs: "0.7rem",
              sm: "0.7rem",
              md: "0.7rem",
              lg: "0.7rem",
              xl: "0.9rem",
            },
          }}
        >
          Sign up to begin your DevOps and SRE maturity.
        </Typography>
      </Box>
      {/* 🔵 Toggle Button (Login | Signup) */}
      <Box
        sx={{
          display: "flex",
          height: "2rem",
          borderRadius: "1.75rem",
          border: "1px solid #E0E0E0",
          background: "#FFF",
          // mb: { xs: 3, sm: 3, md: 3, lg: 3, xl: 4 },
          flexShrink: 0,
        }}
      >
        {/* LOGIN BUTTON */}
        <Box
          onClick={onSwitchToLogin}
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1.75rem",
            background: "transparent",
            //color: isLogin ? "#FFF" : "#000",
            color: "#34044",
            fontWeight: "400", // bold when selected
            cursor: "pointer",

            fontFamily: "Akkurat-Pro",

            transition: "0.2s",
            fontSize: {
              xs: "0.8rem",
              sm: "0.8rem",
              md: "0.8rem",
              lg: "0.8rem",
              xl: "0.8rem",
            },
          }}
        >
          Login
        </Box>

        {/* SIGNUP BUTTON */}
        <Box
          onClick={onSwitchToSignup}
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1.75rem",
            //background: !isLogin ? "#D5DBDE" : "transparent",
            background: "#D5DBDE",
            color: "#34044",
            fontWeight: "400",
            cursor: "pointer",

            fontFamily: "Akkurat-Bold",

            transition: "0.2s",
            fontSize: {
              xs: "0.8rem",
              sm: "0.8rem",
              md: "0.8rem",
              lg: "0.8rem",
              xl: "0.8rem",
            },
          }}
        >
          Sign Up
        </Box>
      </Box>

      {/* FULL NAME */}
      <Box>
        <Typography
          sx={{
            mb: 0.5,
            fontFamily: "Akkurat-Pro",
            fontSize: {
              xs: "0.8rem",
              sm: "0.8rem",
              md: "0.8rem",
              lg: "0.75rem",
              xl: "0.9rem",
            },
            color: "#525252",
          }}
        >
          Full Name*
        </Typography>

        <TextField
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="John Doe"
          variant="standard"
          slotProps={{ input: { disableUnderline: true } }}
          sx={{
            borderRadius: "1.75rem",
            border: "1px solid #E0E0E0",
            px: 2,
            py: 0.5,
            width: "92%",
            height: "25px",
            "& .MuiInputBase-input": {
              fontSize: "0.82rem",
            },

            "& input:-webkit-autofill": {
              WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
              WebkitTextFillColor: "#000",
              caretColor: "#000",
              transition: "background-color 9999s ease-out 0s",
            },
            "& .MuiTypography-root": {
              fontFamily: "Akkurat",
            },
          }}
        />

        {errors.name && (
          <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
            {errors.name}
          </Typography>
        )}
      </Box>

      {/* EMAIL */}
      <Box>
        <Typography
          sx={{
            mb: 0.5,
            fontSize: {
              xs: "0.8rem",
              sm: "0.8rem",
              md: "0.8rem",
              lg: "0.75rem",
              xl: "0.9rem",
            },
            color: "#525252",
          }}
        >
          Business Email*
        </Typography>

        <TextField
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="i.e. john.doe@sandhata.com"
          variant="standard"
          slotProps={{ input: { disableUnderline: true } }}
          sx={{
            borderRadius: "1.75rem",
            border: "1px solid #E0E0E0",
            px: 2,
            py: 0.5,
            width: "92%",
            height: "25px",
            "& .MuiInputBase-input": {
              fontSize: "0.82rem",
            },
            "& .MuiTypography-root": {
              fontFamily: "Montserrat",
            },
            "& input:-webkit-autofill": {
              WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
              WebkitTextFillColor: "#000",
              caretColor: "#000",
              transition: "background-color 9999s ease-out 0s",
            },
          }}
        />

        {errors.email && (
          <Typography
            sx={{
              color: "red",
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.8rem",
                xl: "0.9rem",
              },
            }}
          >
            {errors.email}
          </Typography>
        )}
      </Box>

      {/* PHONE */}
      <Box>
        <Typography
          sx={{
            mb: 0.5,
            fontSize: {
              xs: "0.8rem",
              sm: "0.8rem",
              md: "0.8rem",
              lg: "0.8rem",
              xl: "0.9rem",
            },
            color: "#525252",
          }}
        >
          Phone Number*
        </Typography>

        <Box sx={{ mb: 2 }}>
          <PhoneInput
            country="us"
            value={phoneNumber}
            onChange={handlePhoneChange}
            enableSearch={true}
            countryCodeEditable={false}
            inputStyle={{
              width: "100%",
              borderRadius: "18px",
              fontSize: "15px",
            }}
            buttonStyle={{
              borderRadius: "18px 0 0 18px",
              borderRight: "none",
            }}
            containerStyle={{ width: "100%" }}
          />
          {errors.phone && <Typography sx={errorSx}>{errors.phone}</Typography>}
        </Box>

        {/* <Typography
          sx={{
            color: "#525252",
            fontSize: {
              xs: "0.8rem",
              sm: "0.8rem",
              md: "0.8rem",
              lg: "0.6rem",
              xl: "0.9rem",
            },
            color: "#525252",
          }}
        >
          Include country code
        </Typography> */}

        {/* {errors.phone && (
          <Typography
            sx={{
              color: "red",
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.8rem",
                xl: "0.9rem",
              },
            }}
          >
            {errors.phone}
          </Typography>
        )} */}
      </Box>

      {/* DOMAIN DROPDOWN */}
      <Box>
        <Typography
          sx={{
            mb: 0.5,
            fontSize: {
              xs: "0.8rem",
              sm: "0.8rem",
              md: "0.8rem",
              lg: "0.8rem",
              xl: "0.9rem",
            },
            color: "#525252",
          }}
        >
          Domain*
        </Typography>

        <TextField
          select
          name="domain"
          value={formData.domain}
          onChange={handleChange}
          variant="standard"
          SelectProps={{
            IconComponent: DomainArrowIcon, // 🔥 custom arrow here
          }}
          slotProps={{ input: { disableUnderline: true } }}
          sx={{
            borderRadius: "1.75rem",
            border: "1px solid #E0E0E0",
            px: 2,
            py: 0.5,
            width: "92%",
            height: "25px",
            "& .MuiInputBase-input": {
              fontSize: "0.82rem",
            },
            "& .MuiTypography-root": {
              fontFamily: "Montserrat",
            },
            "& .MuiSelect-icon": {
              right: "12px", // Position arrow
              top: "50%",
              transform: "translateY(-50%)",
              width: "0.7rem", // match your SVG size
              height: "0.8rem",
              pointerEvents: "none",
            },
          }}
        >
          <MenuItem
            value=""
            sx={{
              fontSize: {
                xs: "0.7rem",
                sm: "0.7rem",
                md: "0.7rem",
                lg: "0.7rem",
                xl: "0.8rem",
              },
              color: "#525252",
              "& .MuiTypography-root": {
                fontFamily: "Montserrat",
              },
            }}
          >
            Choose one option
          </MenuItem>

          {domainOptions.map((opt) => (
            <MenuItem
              key={opt.roleName}
              value={opt.roleName}
              sx={{
                fontSize: {
                  xs: "0.7rem",
                  sm: "0.7rem",
                  md: "0.7rem",
                  lg: "0.7rem",
                  xl: "0.8rem",
                },
                color: "#525252",
                "& .MuiTypography-root": {
                  fontFamily: "Montserrat",
                },
              }}
            >
              {opt.roleName}
            </MenuItem>
          ))}
        </TextField>

        {errors.domain && (
          <Typography
            sx={{
              color: "red",
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.8rem",
                xl: "0.8rem",
              },
              "& .MuiTypography-root": {
                fontFamily: "Montserrat",
              },
            }}
          >
            {errors.domain}
          </Typography>
        )}
      </Box>

      {/* ROLE (Manager / Technical) */}
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box sx={{ mr: 10 }}>
          <Typography
            sx={{
              mb: 0.5,
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.8rem",
                xl: "0.8rem",
              },
              color: "#525252",
              "& .MuiTypography-root": {
                fontFamily: "Akkurat-Pro",
              },
            }}
          >
            Role*
          </Typography>

          <FormControl>
            <RadioGroup
              row
              name="role"
              value={formData.role}
              onChange={handleChange}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <FormControlLabel
                value="Manager"
                sx={{
                  color: "#525252",
                  "& .MuiTypography-root": {
                    fontFamily: "Akkurat",
                    fontSize: {
                      xs: "0.7rem",
                      sm: "0.7rem",
                      md: "0.7rem",
                      lg: "0.7rem",
                      xl: "0.8rem",
                    },
                  },
                }}
                control={<Radio />}
                label="Manager"
              />
              <FormControlLabel
                value="Technical"
                control={<Radio />}
                label="Technical"
                sx={{
                  color: "#525252",
                  "& .MuiTypography-root": {
                    fontFamily: "Akkurat",
                    fontSize: {
                      xs: "0.7rem",
                      sm: "0.7rem",
                      md: "0.7rem",
                      lg: "0.7rem",
                      xl: "o.8rem",
                    },
                  },
                }}
              />
            </RadioGroup>
          </FormControl>

          {errors.role && (
            <Typography
              sx={{
                color: "red",
                fontSize: {
                  xs: "0.9rem",
                  sm: "0.9rem",
                  md: "0.9rem",
                  lg: "0.9rem",
                  xl: "0.8rem",
                },
              }}
            >
              {errors.role}
            </Typography>
          )}
        </Box>

        {/* CATEGORY (DevOps / SRE) */}
        {/* <Box>
          <Typography sx={{ mb: 0.5, fontFamily: "Akkurat-Pro", fontSize: { xs: "0.8rem", sm: "0.8rem", md: "0.8rem", lg: "0.8rem", xl: "0.8rem" }, color: '#525252' }}>Category*</Typography>

          <FormControl>
            <RadioGroup
              row
              name="category"
              value={formData.category}
              onChange={handleChange}
              sx={{ display: 'flex', flexDirection: 'column' }}
            >
              <FormControlLabel value="DevOps" control={<Radio />} label="DevOps" sx={{
                color: '#525252', "& .MuiTypography-root": {
                  fontFamily: "Akkurat",
                  fontSize: { xs: "0.7rem", sm: "0.7rem", md: "0.7rem", lg: "0.7rem", xl: "0.8rem" },
                },
              }} />
              <FormControlLabel value="SRE" control={<Radio />} label="SRE" sx={{
                color: '#525252', "& .MuiTypography-root": {
                  fontFamily: "Akkurat",
                  fontSize: { xs: "0.7rem", sm: "0.7rem", md: "0.7rem", lg: "0.7rem", xl: "0.8rem" },
                },
              }} />
            </RadioGroup>
          </FormControl>

          {errors.category && (
            <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
              {errors.category}
            </Typography>
          )}
        </Box> */}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box sx={{ mr: 10 }}>
          <FormControl>
            <Typography sx={labelSx}>Contact Preference (Optional)</Typography>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.emailContact}
                    onChange={handleCheckBoxChange}
                    name="emailContact"
                  />
                }
                label="Email"
                sx={{
                  color: "#525252",
                  "& .MuiTypography-root": {
                    fontFamily: "Akkurat",
                    fontSize: "0.75rem",
                  },
                }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.phoneContact}
                    onChange={handleCheckBoxChange}
                    name="phoneContact"
                  />
                }
                label="Phone"
                sx={{
                  color: "#525252",
                  "& .MuiTypography-root": {
                    fontFamily: "Akkurat",
                    fontSize: "0.75rem",
                  },
                }}
              />
            </FormGroup>
          </FormControl>
          {errors.contactPreference && (
            <Typography sx={errorSx}>{errors.contactPreference}</Typography>
          )}
        </Box>
      </Box>
      {/* SUBMIT BUTTON */}
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.isAgree}
            onChange={handleCheckBoxChange}
            name="isAgree"
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 22,
              },
            }}
          />
        }
        label={
          <Typography
            sx={{
              mt: 0.5,
              fontSize: {
                xs: "0.7rem",
                sm: "0.7rem",
                md: "0.7rem",
                lg: "0.7rem",
                xl: "0.9rem",
              },
              textAlign: "left",
              color: "#939292ff",
              "& .MuiTypography-root": { fontFamily: "Montserrat" },
            }}
          >
            I agree to provide my name, organization email, and phone number to
            take the DevOps and SRE Maturity Assessment. The details will be
            treated confidentially and processed in strict accordance with GDPR
            requirements
          </Typography>
        }
      />
       {errors.isAgree && (
            <Typography sx={errorSx}>{errors.isAgree}</Typography>
          )}

      <Button
        onClick={handleSubmit}
        sx={{
          width: "12rem",
          height: "2.5rem",
          background: "#0036DD",
          color: "#FFF",
          fontSize: {
            xs: "0.8rem",
            sm: "0.8rem",
            md: "0.8rem",
            lg: "0.8rem",
            xl: "0.9rem",
          },
          borderRadius: "1.75rem",
          textTransform: "none",
          fontFamily: "Akkurat-Pro",
          "&:hover": { background: "#002FCC" },
        }}
      >
        Create Account
      </Button>

      <Divider />

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* 🔵 LABEL */}
        <Typography
          sx={{
            fontSize: {
              xs: "0.7rem",
              sm: "0.7rem",
              md: "0.7rem",
              lg: "0.7rem",
              xl: "0.9rem",
            },
            textAlign: "left",
            cursor: "pointer",
            color: "#525252",
            fontFamily: "Akkurat-Bold",
          }}
        >
          Got a query?
        </Typography>

        {/* 🔵 CLICKABLE TEXT WITH LOGIC */}
        <Typography
          sx={{
            mt: 0.5,
            fontSize: {
              xs: "0.7rem",
              sm: "0.7rem",
              md: "0.7rem",
              lg: "0.7rem",
              xl: "0.9rem",
            },
            textAlign: "left",
            cursor: "pointer",
            color: "#939292ff",
            "& .MuiTypography-root": { fontFamily: "Montserrat" },
          }}
        >
          We're here to help! Please complete the{" "}
          <Box
            component="span"
            sx={{
              color: "#0036DD",
              textDecoration: "underline",
              cursor: "pointer",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={async () => {
              setOpen(true);
              // 1️⃣ Validate email
              // if (!formData.email || formData.email.trim() === "") {
              //   setNotif({
              //     open: true,
              //     success: false,
              //     text: "Please enter your email to continue.",
              //   });
              //   return;
              // }

              // navigate("/contactus-page", {
              //   state: {
              //     name: formData.name,
              //     email: formData.email,
              //     phone: phoneNumber,
              //     userDomain: formData.domain,
              //     // domain: formData.category,
              //     userRole: formData.role,
              //   },
              // });
              // 5️⃣ Navigate if not an existing user
              // window.location.href = "/contactus-page";
            }}
          >
            Contact Us
          </Box>
          <br />
          and our executives will connect with you shortly.
        </Typography>
      </Box>

      {/* Notifications */}
      <Notification
        open={notif.open}
        success={notif.success}
        text={notif.text}
        onClose={() => setNotif((p) => ({ ...p, open: false }))}
      />
      <ContactUsPopup
        open={open}
        onClose={() => setOpen(false)}
        prefillData={{
          name: formData.name ? formData.name : "",
          email: formData.email ? formData.email : "",
          phone: phoneNumber ? phoneNumber : "",
          userDomain: formData.domain ? formData.domain : "",
          userRole: formData.role ? formData.role : "",
        }}
      />
      {/* Loader */}
      <GlassLoaderOverLay open={loading} />
    </Box>
  );
}